/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( '.projects-archive__select-filter' ).on( 'change', function() {
        const filter = $( this ).val();
        window.location.href = filter;
      } );

      $( '.projects-archive' ).each( function( key, val ) {
        const height = $( val ).height();
        const barHeight = $( '.project__filter-bar-wrapper' ).outerHeight();

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: '.project__filter-bar-wrapper',
            pin: '.project__filter-bar-wrapper',
            start: 'top ' + ( window.innerHeight - barHeight ),
            end: '+=' + ( height - barHeight ),
            scrub: 0,
            // markers: true,
            onRefresh: ( self ) => {
              self.spacer.classList.add( 'pointer-events-none' );
              $( '.project__filter-bar-wrapper' ).addClass( 'is-active' );
            },
          },
        } );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'project', COMPONENT );
} )( app );
